import SvgIcon from "./IconPlus.svg?react";

export const IconPlus = SvgIcon;
